<script setup>
import {defineProps, ref} from "vue";
import useHelper from "@/composables/useHelper";

const {getLockContentLabel} = useHelper();

const props = defineProps({
    content: Object,
    index: Number,
})

const contentType =  getLockContentLabel(props.content.quest_type_key, props.content.content_type_vertical ?? null);
const showLockDetails = ref(true);
</script>

<template>
    <div v-if="showLockDetails" class="flex items-start justify-between rounded-md bg-sky-700/20 px-8 py-4">
        <div class="flex flex-1 items-center space-x-4">
            <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor"
                     class="h-6 w-6 stroke-sky-600">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"/>
                </svg>
            </div>
            <div class="space-y-1">
                <p class="font-bold text-sky-700">{{ $tt('path_page__lock_title', {content_type: contentType}) }}?</p>
                <ul class="list-inside list-disc font-light text-sky-700 text-sm">
                    <li class="list-item" v-if="props.content.lock_reason == 1">
                        {{ $tt('path_page__lock_message_not_before', {content_type: contentType, not_before: props.content.not_before}) }}
                    </li>
                    <li class="" v-if="props.content.lock_reason == 2">
                        {{ $tt('path_page__lock_message_previous_not_completed', {content_type: contentType}) }}
                    </li>
                </ul>
            </div>
        </div>
        <div>
            <button @click="showLockDetails = false">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                     stroke="currentColor"
                     class="h-6 w-6 text-gray-600">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
        </div>
    </div>
</template>


